import { useEffect } from 'react';

import { urls } from '@repo/app-constants';
import { Kit } from '@repo/types';
import { TextColor, Typography } from '@repo/ui';
import LineChartIcon from 'assets/images/home/recommended-for-you/graph.svg?react';
import {
  ButtonColors,
  ButtonSizes,
  ButtonVariants,
  DesignButton,
} from 'components';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import { useShowTinyPlusUpsell } from 'hooks/useShowTinyPlusUpsell';
import { CARD_TITLE_COLORS } from 'views/Home/HomeContent/RecommendedForYou/constants/cardTitleColors';

import styles from './TinyPlusUpsellBanner.module.css';

// Distinct banner for the submetric detail page (Figma node 2152-8149).
// Other contextual placements reuse the homepage `RecommendedCard` instead —
// see `components/TinyPlusUpsellCard`.
export const TinyPlusUpsellBanner = ({ kit }: { kit?: Kit | null }) => {
  const show = useShowTinyPlusUpsell(kit);
  const { trackEvent, trackEventOnce } = useAnalytics();

  useEffect(() => {
    if (show) {
      trackEventOnce('Tiny Plus Contextual Card Viewed', 'submetric', {
        placement: 'submetric',
      });
    }
  }, [show, trackEventOnce]);

  if (!show) return null;

  const handleClick = () => {
    trackEvent('Tiny Plus Contextual Card Clicked', {
      text: 'Upgrade to Tiny+',
      href: urls.TINY_PLUS_UPGRADE_OFFER,
      isExternal: true,
      placement: 'submetric',
    });
    window.open(urls.TINY_PLUS_UPGRADE_OFFER, '_blank');
  };

  return (
    <div className={styles.banner}>
      <LineChartIcon className={styles.icon} aria-hidden />
      <div className={styles.content}>
        <Typography
          variant='heading-s'
          style={{ color: CARD_TITLE_COLORS.yellow }}
          className={styles.title}
        >
          Test regularly to monitor and manage issues.
        </Typography>
        <Typography
          variant='label'
          color={TextColor.GREY}
          className={styles.description}
        >
          Tiny+ members save $80 per resampling kit.
        </Typography>
      </div>
      <DesignButton
        label='Upgrade to Tiny+'
        onClick={handleClick}
        variant={ButtonVariants.SOLID}
        color={ButtonColors.DARK_YELLOW}
        size={ButtonSizes.S}
        className={styles.button}
      />
    </div>
  );
};
